import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/details/updateBillableStatusForFieldReport`;

export const ROUTE: RouteDefinition = `${baseRoute}/details/updateBillableStatusForFieldReport`;

export const URL = (): RouteDefinition => `${baseRoute}/details/updateBillableStatusForFieldReport`;
